import 'twin.macro';

import { UseFormHandleSubmit, UseFormRegister, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormField } from '@/routes/create-session/components/CreateSessionForm';
import { FormInputType, FormValues } from '@/routes/create-session/types';

import { Modal } from './base';

const FIELDS = [
  {
    id: 'expiredAt',
    name: 'expiredAt',
    label: 'สัมภาษณ์ได้ถึง',
    placeholder: 'กรุณากรอกวันที่',
    required: true,
    type: FormInputType.DATE,
  },
  {
    id: 'duration',
    name: 'duration',
    label: 'ต้องสัมภาษณ์ให้เสร็จภายใน (ชม.)',
    placeholder: 'กรอกตัวเลข เช่น 2 3',
    required: true,
    type: FormInputType.NUMBER,
    validation: { valueAsNumber: true },
  },
];

export interface ResetInterviewModalProps {
  handleModalClose: () => void;
  handleSubmit: UseFormHandleSubmit<FormValues>;
  handleResetInterview: (data: FormValues) => void;
  intervieweeName: string;
  intervieweeEmail: string;
  refId?: string;
  position: string;
  register: UseFormRegister<FormValues>;
  errors: ReturnType<typeof useForm>['formState']['errors'];
  isResetInterviewLoading: boolean;
  resetInterviewError: Error | undefined;
  duration?: number;
}

const ResetInterviewModal = ({
  handleModalClose,
  handleSubmit,
  intervieweeName,
  intervieweeEmail,
  refId,
  position,
  register,
  errors,
  duration,
  handleResetInterview,
  isResetInterviewLoading,
}: ResetInterviewModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      title="ล้างข้อมูลการสัมภาษณ์"
      primaryButtonAction={handleSubmit(handleResetInterview)}
      primaryButtonText="ล้างข้อมูล"
      secondaryButtonAction={handleModalClose}
      secondaryButtonText="ยกเลิก"
      loading={isResetInterviewLoading}
      description={
        <div tw="flex flex-col gap-4">
          <img tw="block h-20 w-20 p-2" src="/assets/people-placeholder.png" alt="skooldio" />
          <div tw="flex flex-col gap-1">
            <p tw="font-light text-sm text-gray-600">{refId ? `${refId}` : ''}</p>
            <p tw="text-3xl font-bold">{intervieweeName}</p>
            <p tw="font-light text-gray-600">{intervieweeEmail}</p>
          </div>
          <div tw="flex flex-col gap-1">
            <p tw="font-bold text-black">
              {t([
                'intervieweeProfiles.position.label',
                'intervieweeProfiles.position.viewerLabel',
              ])}
            </p>
            <p tw="font-light text-gray-600">{position}</p>
          </div>

          {FIELDS.map((field) => {
            return (
              <FormField
                key={field.name}
                label={field.label}
                name={field.name as keyof FormValues}
                placeholder={field.placeholder}
                register={register}
                required={field.required}
                type={field.type}
                validation={field.validation}
                error={errors[field.name as keyof FormValues]}
                defaultValue={field.name === 'duration' ? duration : undefined}
              />
            );
          })}
        </div>
      }
    />
  );
};

export default ResetInterviewModal;
